import { render } from "./ModalHeaderProfile.vue?vue&type=template&id=19150db9&scoped=true&ts=true"
import script from "./ModalHeaderProfile.vue?vue&type=script&lang=ts"
export * from "./ModalHeaderProfile.vue?vue&type=script&lang=ts"

import "./ModalHeaderProfile.vue?vue&type=style&index=0&id=19150db9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19150db9"]])

export default __exports__